import { render, staticRenderFns } from "./AlgorithmePersonnalisationAlimentaire.vue?vue&type=template&id=67771b36&scoped=true"
var script = {}
import style0 from "./AlgorithmePersonnalisationAlimentaire.vue?vue&type=style&index=0&id=67771b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67771b36",
  null
  
)

export default component.exports